function cartVariants(product, select) {
  new Shopify.OptionSelectors(select, {
    product: product,
    enableHistoryState: false
  });
}

function cartVariantsUpdate() {
  $(".show-variant .edit").on("click", function(e) {
    e.preventDefault();
    const $this = $(this);
    $this.closest("tr").addClass("selected");
    $this.closest(".show-variant").hide().next(".edit-variant").show();
  });

  $(".submit-variant").on("click", function(e) {
    e.preventDefault();
    const $this = $(this);
    const $tr = $this.closest("tr");
    const qty = $tr.find('[name="updates[]"]').val();
    const $select = $this.closest(".edit-variant").find(".variant-select");
    const currentId = $select.data("current-id");
    const currentVal = $select.val();
    $.ajax({
      url: "/cart/update.js",
      type: "post",
      dataType: "json",
      data: `updates[${currentId}]=0&updates[${currentVal}]=${qty}`
    })
      .done(() => {
        window.location.reload();
      })
      .fail(data => {
        alert("Variant is not available.");
      });
  });
}

module.exports = {
  cartVariants,
  cartVariantsUpdate
};



// WEBPACK FOOTER //
// ../assets/js/cart-variants.js